import React, { Component } from 'react'
import isEqual from 'lodash/isEqual'

import { RawHtml, SnippetContent } from '../..'
import {
  fetchRatings,
  getNumberOfActiveFilters,
  MoreProductsProvider,
  MediaResize,
  getAggregationToRender,
} from '../../../utils'
import { withFeatureFlags } from '../../../utils/providers'
import {
  trackCategoryView,
  trackProductListView,
} from '../../../utils/Alphapet/tracking'

import { FilterSidebar, MobileFilter, SortDropdown } from '../ProductListFilter'
import ProductListCount from '../ProductListCount'
import List from './List'
import SubCategorySidebar from './SubCategorySidebar'

class ProductList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isMobileFilterVisible: false,
      isLoading: false,
      productRatings: null,
    }
  }

  componentDidMount() {
    this.updateRatings()
    const { products, categoryData } = this.props
    // Page info pushing to dataLayer for Makaira Trackings
    if (categoryData) {
      trackCategoryView(categoryData)
      trackProductListView({ products, categoryId: categoryData.id })
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.products, this.props.products)) {
      this.updateRatings()
    }
  }

  updateRatings = () => {
    if (this.props.isFeatureEnabled('product.ratings')) {
      fetchRatings(this.props.products)
        .then((results) => {
          this.setState({
            productRatings: results,
          })
        })
        .catch((error) => {
          console.error(error)
        })
    }
  }

  handleFormSubmit = async (options = {}) => {
    const { resetPagination = false } = options

    this.setState({ isLoading: true })
    await this.props.submitForms({ resetPagination })
    this.setState({ isLoading: false })
  }

  handleFormSubmitWithPaginationReset = async () => {
    return await this.handleFormSubmit({ resetPagination: true })
  }

  render() {
    const {
      products = [],
      aggregations = {},
      resetAllFilters,
      queryParams = {},
      totalProductCount = 0,
      categoryData = {},
      searchData = {},
    } = this.props

    if (totalProductCount < 1) {
      return <SnippetContent snippetId="empty_search_list" />
    }

    const numberOfActiveFilters = getNumberOfActiveFilters({ aggregations })
    const filterProps = {
      aggregations: getAggregationToRender(aggregations),
      numberOfActiveFilters,
      totalProductCount,
      submitForms: this.handleFormSubmitWithPaginationReset,
      resetAllFilters,
      categoryUrls: categoryData.url,
      searchData,
    }

    return (
      <MoreProductsProvider products={products}>
        <section className="container" id="product_listing">
          <div className="row mt-lg-3">
            <aside className="col col-12 col-md-4 col-lg-3">
              {categoryData?.subcategories_data?.length > 0 && (
                <MediaResize up="MD">
                  <SubCategorySidebar categoryData={categoryData} />
                </MediaResize>
              )}
              {Object.keys(aggregations).length > 0 && (
                <>
                  <MediaResize up="MD">
                    <FilterSidebar {...filterProps} />
                  </MediaResize>
                  <MediaResize down="MD">
                    <MobileFilter {...filterProps} />
                  </MediaResize>
                </>
              )}
            </aside>
            <div className="col col-12 col-md-8 col-lg-9">
              <MediaResize up="MD">
                <div className="d-flex mb-4 align-items-center justify-content-between bg-white">
                  <ProductListCount count={totalProductCount} />
                  <SortDropdown
                    queryParams={queryParams}
                    submitForms={this.handleFormSubmit}
                  />
                </div>
              </MediaResize>
              <List
                products={products}
                queryParams={queryParams}
                totalProductCount={totalProductCount}
                submitForms={this.handleFormSubmit}
                isLoading={this.state.isLoading}
                productRatings={this.state.productRatings}
                categoryUrls={categoryData.url}
                searchData={searchData}
                trackingData={{ origin: 'listing-page' }}
              />
              {categoryData && categoryData?.longdesc && (
                <RawHtml
                  className="mb-4"
                  element="div"
                  html={categoryData.longdesc}
                  forceStrictMode={true}
                />
              )}
            </div>
          </div>
        </section>
      </MoreProductsProvider>
    )
  }
}

export default withFeatureFlags(ProductList)
export { List, MoreProductsProvider }
